export default[
    {
        path: 'saleOrder',
        name: 'SaleOrder',
        component: () => import(/* webpackChunkName: "orderManage" */ '@/views/sale/orderManage/index.vue'),
    },
];
